import { mapActions } from 'vuex';
import { decode } from 'utils/general';

/**
 * Product How To Use component
 */
export default {
  components: {
    accordion: () => import('../accordion/accordion.vue'),
    'vue-image': () => import('../vue-image/vue-image.vue'),
    'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
    modal: () => import('../modal/modal.vue'),
    'product-video': () => import('../product-video/product-video.vue'),
  },
  props: ['videos', 'images', 'contents'],
  data() {
    return {
      itemList: [],
      selectedVideo: '',
    };
  },
  created() {
    for (var i = 0; i < this.contentsDecoded.length; i++) {
      if (this.videosDecoded || this.imagesDecoded || this.contentsDecoded) {
        this.itemList.push({
          video: this.videosDecoded ? this.videosDecoded[i] : false,
          image: this.imagesDecoded ? this.imagesDecoded[i][0].src : false,
          body: this.contentsDecoded
            ? this.contentsDecoded[i].replace('<h4', '<h4 class="h4 bold"')
            : false,
        });
      }
    }
  },
  computed: {
    videosDecoded() {
      return JSON.parse(decode(this.videos));
    },
    imagesDecoded() {
      return JSON.parse(decode(this.images));
    },
    contentsDecoded() {
      return JSON.parse(decode(this.contents));
    },
  },
  methods: {
    ...mapActions('global', ['openModal']),
    openFeaturedModal(video) {
      if (video.length === 0) return;
      this.selectedVideo = `https://www.youtube.com/embed/${video
        .split('/')
        .pop()}?enablejsapi=1`;
      this.openModal('viewVideoContent');
    },
  },
};
